

const Footer = () => {
    return (
        <section className="container bd-grid">
            <div className="footer">
                <div className="footer_items">
                    <p>©2023, Toodnotes.vercel.app</p>
                </div>
                <div className="footer_items">
                    <a href="https://www.instagram.com/bianco_juani/" className="footer_links" target="_blank">Developer by Juan Bianco.</a>
                </div>
            </div>
        </section>
    )
}

export default Footer